exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container.sitemap,\r\n.app-container.sitemap main,\r\n.app-container.sitemap #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.sitemap .view-container {\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.sitemap .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
